import { SectionFrameProps } from '../pages/homepage/components/SectionFrame';
import { LinkId } from '../constants';

export type DynamicAsset = any;

export enum DynamicAssetsKeys {
  chatUrl = 'chatUrl',
  contactAgreementContainer = 'contactAgreementContainer',
  expertSessionsPath = 'expertSessionsPath',
  expertSessionsCallMeLaterSubtitle = 'expertSessionsCallMeLaterSubtitle',
  loggedInFooterNavLinks = 'loggedInFooterNavLinks',
  footerNavLinks = 'footerNavLinks',
  loggedInHeaderNavLinks = 'loggedInHeaderNavLinks',
  headerNavLinks = 'headerNavLinks',
  protectItImage = 'protectItImage',
  headerMobileCtaComponent = 'headerMobileCtaComponent',
  homeCallToAction = 'homeCallToAction',

  footerPartnerLogoImage = 'footerPartnerLogoImage',
  footerPartnerLogoHref = 'footerPartnerLogoHref',

  footerOnlineClaimButtonEnabled = 'footerOnlineClaimButtonEnabled',

  confirmationPageDetailsLogo = 'confirmationPageDetailsLogo',

  productName = 'productName',

  finePrintIcon1 = 'fine-print-icon-1.svg',
  finePrintIcon2 = 'fine-print-icon-2.svg',
  finePrintIcon3 = 'fine-print-icon-3.svg',

  homeHeroSpacerComponent = 'homeHeroSpacerComponent',
  homeHeroTitle = 'homeHeroTitle',
  homeHeroTitleComponent = 'homeHeroTitleComponent',
  homeHeroSubtitle = 'homeHeroSubtitle',
  homeHeroSubtitleComponent = 'homeHeroSubtitleComponent',
  homeHeroImage = 'home-hero-cover.jpg',
  homeHeroImageContainerComponent = 'homeHeroImageContainerComponent',

  valueCalculatorHeading1 = 'valueCalculatorHeading1',
  valueCalculatorHeading2 = 'valueCalculatorHeading2',
  valueCalculatorHeadingComponent = 'valueCalculatorHeadingComponent',
  valueCalculatorSubtitle = 'valueCalculatorSubtitle',

  homeProtectItTitleComponent = 'homeProtectItTitleComponent',
  homeProtectItTitle = 'homeProtectItTitle',
  homeProtectItSubtitle = 'homeProtectItSubtitle',
  homeProtectItSubtitleComponent = 'homeProtectItSubtitleComponent',
  homeProtectItSubtitle2 = 'homeProtectItSubtitle2',
  homeProtectItCtaComponent = 'homeProtectItCtaComponent',
  homeProtectItTextContainer = 'homeProtectItTextContainer',
  homeProtectItContainer = 'homeProtectItContainer',

  homeValuePropTitleComponent = 'homeValuePropTitleComponent',
  homeValuePropImageContainer = 'homeValuePropImageContainer',
  homeValuePropContent = 'homeValuePropContent',

  calculatorResultsHeadingComponent = 'calculatorResultsHeadingComponent',
  calculatorResultsHeading = 'calculatorResultsHeading',
  calculatorResultsSubheading = 'calculatorResultsSubheading',
  calculatorResultsIndividualHeading = 'calculatorResultsIndividualHeading',
  calculatorResultsTableData = 'calculatorResultsTableData',
  calculatorResultsLogoComponent = 'calculatorResultsLogoComponent',
  calculatorDisclaimer2 = 'calculatorDisclaimer2',

  finePrintTitleComponent = 'finePrintTitleComponent',
  finePrintTitle = 'finePrintTitle',
  finePrintSection1Title = 'finePrintSection1Title',
  finePrintSection1Detail = 'finePrintSection1Detail',
  finePrintSection2Title = 'finePrintSection2Title',
  finePrintSection2Details = 'finePrintSection2Details',
  finePrintSection3Title = 'finePrintSection3Title',
  finePrintSection3Details = 'finePrintSection3Details',
  finePrintLinkEnabled = 'finePrintLinkEnabled',
  finePrintLinkText = 'finePrintLinkText',
  finePrintLinkTo = 'finePrintLinkTo',
  finePrintLinkLabel = 'finePrintLinkLabel',

  testimonialTitleComponent = 'testimonialTitleComponent',
  testimonialTitle = 'testimonialTitle',
  testimonialSubtitle = 'testimonialSubtitle',
  testimonialBody = 'testimonialBody',

  signupTitleComponent = 'signupTitleComponent',
  signupSubtitleComponent = 'signupSubtitleComponent',
  signupPricingComponent = 'signupPricingComponent',
  signupImageComponent = 'signupImageComponent',

  signupValueProp1 = 'signupValueProp1',
  signupValueProp2 = 'signupValueProp2',
  signupValueProp3 = 'signupValueProp3',

  signupImage1 = 'signup-image-1.jpg',
  signupImage2 = 'signup-image-2.jpg',
  signupImage3 = 'signup-image-3.jpg',
  signupImage4 = 'signup-image-4.jpg',
  signupImage5 = 'signup-image-5.jpg',

  contactSubmitButtonId = 'contactSubmitButtonId',
  residenceSubmitButtonId = 'residenceSubmitButtonId',
  billingSubmitButtonId = 'billingSubmitButtonId',
  reviewSubmitButtonId = 'reviewSubmitButtonId',
  confirmationCallButtonId = 'confirmationCallButtonId',
  confirmationChatButtonId = 'confirmationChatButtonId',
  confirmationExpertSessionsButtonId = 'confirmationExpertSessionsButtonId',

  confirmationWelcomeMessage = 'confirmationWelcomeMessage',
  confirmationChatHeading = 'confirmationChatHeading',
  confirmationChatMessage = 'confirmationChatMessage',
  confirmationCallMessage = 'confirmationCallMessage',
  confirmationCallHeading = 'confirmationCallHeading',
  confirmationCallComponent = 'confirmationCallComponent',

  whatsCoveredCallToActionTitle = 'whatsCoveredCallToActionTitle',
  whatsCoveredCallToActionComponent = 'whatsCoveredCallToActionComponent',
  whatsCoveredCallToActionInverted = 'whatsCoveredCallToActionInverted',

  expertChatAppKey = 'expertChatAppKey',
  expertChatSdkEnabled = 'expertChatSdkEnabled',
}

export type DynamicAssets = { [key in DynamicAssetsKeys]: DynamicAsset };

export type NavItem = {
  id: LinkId;
  label: string;
  to?: string;
  target?: string;
  onClick?: (event: React.MouseEvent) => void;
};

export type ValuePropItem = string | JSX.Element;

export type ValuePropositionContent = {
  icon: any;
  caption: ValuePropItem;
  title: ValuePropItem;
  subtitle: ValuePropItem;
  points: ValuePropItem[];
  image: any;
  link?: ValuePropItem;
  imageMargins: SectionFrameProps;
  contentMargins: SectionFrameProps;
  shouldShowBanner?: boolean;
  label?: string;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/models.ts